import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    ActionType,
} from "../services/types/ComponentTypes";

export const screen_2203_emp_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Employees",
        fabAction: {
            type: "add",
            screenId: "2205",
        },
        style: {
            backgroundColor: "#f3f4f6",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                style: {
                    backgroundColor: "#ffffff",
                    borderRadius: 9,
                    direction: FlexDirection.COLUMN,
                },
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        titleValue: "name",
                        Name: "emp_summary",
                        SummeryActions: [
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "emp_profile_add/<id>",
                                },
                                ActionType: "Edit",
                                ScreenId: "2205",
                                visibility: [1],
                            },
                            {
                                Action: {
                                    Action: "Delete",
                                    Module: "emp_summary",
                                },
                                ActionType: "Delete",
                                ScreenId: "hrm/employees",
                                visibility: [1],
                            },
                            {
                                Action: {
                                    Action: "PDF",
                                    Settings: "employee_details",
                                },
                                ActionType: ActionType.PDF_DOWNLOAD,
                            },
                        ],
                        Form: {
                            Name: "emp_summary",
                            TableName: "employee",
                            DisplayName: "",
                            Filter: "employee.soft_delete=0",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "id",
                                    BindValue: "id",
                                    Json_Attribute: "id",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: false,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Name",
                                    BindValue: "name",
                                    Json_Attribute: "name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Mobile",
                                    BindValue: "txt_mobile",
                                    Json_Attribute: "mobile",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true,
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Group",
                                    IsMandatory: true,
                                    BindValue: "drp_group",
                                    Json_Attribute: "group_id",
                                    componentType: ComponentType.SEARCHABLE_DROPDOWN, // Assumption based on Search_Select
                                    showInSummary: true,
                                    LookupName: "employee_group",
                                },
                            ],
                        },
                    },
                ],
            },
        ],
    },
];
